import {Injectable} from '@angular/core';
import {CxEvent} from '@spartacus/core';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class DcpDataService<T> {
  abstract getData(event: CxEvent): T | Observable<T>;

  abstract fillData(event: CxEvent, ...args: any[]): T | Observable<T>;
}
